module.exports = __webpack_public_path__ + "img/distribucion.91aa94ce.png";